





























import { Vue } from 'vue-property-decorator';
import UserRead from '@/objects/users/UserRead';
import PermissionType from '@/objects/users/permissionType.enum';
import store from '@/store';

const Component = Vue.extend({
  data() {
    return {
      permissions: PermissionType,
    };
  },

  async mounted() {
    this.secureRootNotAvailableSetup();
    this.stillLoggedInSetup();
    this.idleSetup();
  },
  computed: {
    self() {
      return this.$store.state.self.user as UserRead;
    },
  },
  methods: {
    logOff() {
      store.dispatch('self/logOff');
      this.$router.push({ path: 'public' });
    },
    canAccess(permissions: PermissionType[]): boolean {
      const s = this.self;
      if (!s) {
        return false;
      }

      return !!permissions.filter((value) => s.permissions.includes(value));
    },
    secureRootNotAvailableSetup() {
      if (this.$router.currentRoute.name === 'Secure') {
        this.$router.push({ path: '/secure/dashboard' });
      }
    },
    stillLoggedInSetup() {
      const handle = setInterval(async () => {
        const isGood = await store.dispatch('self/getSelf', true);
        if (!isGood) {
          clearInterval(handle);
        }
      }, 1000 * 60);
    },
    idleSetup() {
      let idleHandler: number;

      function startTimer() {
        idleHandler = window.setTimeout(() => {
          store.dispatch('self/logOff', true);
          startTimer();
        }, 1000 * 60 * 60); // 30 minute inactivity timeout
      }

      function resetTimer() {
        window.clearTimeout(idleHandler);
        startTimer();
      }

      window.addEventListener('mousemove', resetTimer, false);
      window.addEventListener('mousedown', resetTimer, false);
      window.addEventListener('keypress', resetTimer, false);
      window.addEventListener('DOMMouseScroll', resetTimer, false);
      window.addEventListener('mousewheel', resetTimer, false);
      window.addEventListener('touchmove', resetTimer, false);
      window.addEventListener('MSPointerMove', resetTimer, false);

      startTimer();
    },
  },
});

export default Component;
